export default () => {
    const systemRequirementsBtn = document.querySelectorAll('.system-requirement-radio-label');
    if (systemRequirementsBtn.length === 0)
        return;
    import(/* webpackChunkName: "system requirements button" */ "../classes/systemRequirements")
        .then(({ default: systemRequirements }) => {
        systemRequirementsBtn.forEach(systemRequirementBtn => {
            new systemRequirements(systemRequirementBtn);
        });
    })
        .catch(() => "An error with system requirements button component occurred");
};
